import React, { useState } from "react"
import { ReactComponent as DownArrow } from "../../../icons/chevronDown.svg"
import Avatar from "boring-avatars"

const AVATAR_COLORS = ["#d5d8c7", "#d4d6ce", "#d3d5d5", "#d1d3dc", "#d0d2e3"]

const sizePx = {
  small: 40,
  medium: 128,
  large: 256,
}

const UserAvatar = ({
  handleClick,
  user = null,
  inHeader = false,
  size = "small",
}) => {
  const [imageFailed, setImageFailed] = useState(false)
  const avatarUrl =
    size === "small" && user.avatar_url_small
      ? user.avatar_url_small
      : size === "medium" && user.avatar_url_medium
        ? user.avatar_url_medium
        : user.avatar_url_large
          ? user.avatar_url_large
          : null
  const sizeChart = {
    small: { width: "10" },
    medium: { width: "32" },
    large: { width: "64" },
  }
  const name = user.band ? user.band.name : user.nickname || user.first_name
  const px = sizePx[size] ?? sizePx.small
  const avatarSeed = `${name || ""}${user.id}`
  return (
    <div
      onClick={handleClick}
      className={`flex items-baseline ${
        inHeader ? "ml-1 lg:ml-2 cursor-pointer" : ""
      }`}
    >
      <div
        title={name}
        className={`userAvatar w-${sizeChart[size].width} overflow-hidden ${
          inHeader ? "rounded-full" : "rounded-md"
        }`}
      >
        {avatarUrl && !imageFailed ? (
          <img
            className="h-full w-full"
            src={avatarUrl}
            alt={name}
            onError={() => setImageFailed(true)}
          />
        ) : (
          <div className="boring-avatar-wrap">
            <Avatar
              size={px}
              name={avatarSeed}
              variant="beam"
              colors={AVATAR_COLORS}
              square
            />
          </div>
        )}
      </div>
      {inHeader ? <DownArrow className="hover:opacity-50" /> : null}
    </div>
  )
}

export default UserAvatar
